import { render, staticRenderFns } from "./DappDetailedView.vue?vue&type=template&id=47883c1c&scoped=true"
import script from "./DappDetailedView.vue?vue&type=script&lang=ts"
export * from "./DappDetailedView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47883c1c",
  null
  
)

export default component.exports